import type { ChangeEvent } from '@atlassian/jira-issue-view-model/src/change-type';
import type { CardId, Card } from '../../../../model/types';

export const CARD_REFRESH_REQUEST = 'state.actions.cards.refresh.CARD_REFRESH_REQUEST' as const;

export const CARD_REFRESH_SUCCESS = 'state.actions.cards.refresh.CARD_REFRESH_SUCCESS' as const;

export type CardRefreshRequestAction = {
	type: typeof CARD_REFRESH_REQUEST;
	payload: {
		cardId: CardId | undefined;
		changeEvent: ChangeEvent | null;
	};
};

export const cardRefreshRequest = (
	cardId?: CardId,
	changeEvent?: ChangeEvent,
): CardRefreshRequestAction => ({
	type: CARD_REFRESH_REQUEST,
	payload: {
		cardId,
		changeEvent: changeEvent || null,
	},
});

export type CardRefreshSuccessAction = {
	type: typeof CARD_REFRESH_SUCCESS;
	payload: Card;
};

export const cardRefreshSuccess = (card: Card): CardRefreshSuccessAction => ({
	type: CARD_REFRESH_SUCCESS,
	payload: card,
});

export type Action = CardRefreshRequestAction | CardRefreshSuccessAction;
